
import React from 'react';
import { useNavigate } from 'react-router-dom';

export const DestinationsSection: React.FC = () => {
  const navigate = useNavigate();

  const destinations = [
    {
      id: 1,
      name: 'Algeria',
      image: '/images/adventure-dest-1.jpg',
      description: 'Discover the blend of history, culture and stunning Mediterranean beauty with curated holiday packages. Dive into an unforgettable journey where every corner narrates a story, and every moment captivates your soul.',
      details: 'Have you ever wondered what it is like to wander through the vibrant streets of a place nestled between the Mediterranean and steep forested hills, where history whispers through the ancient walls? Get ready to get lost in the exotic lanes of Algerian, lose yourself in the maze-like chark of the Kasbah, or taste the flavours of Algerian cuisine. Because your journey to explore the beautiful location in North Africa is about to begin!'
    },
    {
      id: 2,
      name: 'Egypt',
      image: '/images/adventure-dest-2.jpg',
      description: 'Tourists from all corners of the world visit Egypt and book their Nile cruise packages online to explore the various tombs, beautiful temples, ancient ruins, and striking structures of an era long gone.',
      details: 'Moreover, the serene Nile River only adds to the beauty of this marvellous country. The country is not only huge tracts of desert as it may seem to the uninitiated, as a lot of water activities await you in Egypt, like surfing, sailing, and diving. History enthusiasts will love the capital city of Cairo while those looking for some solitude can head straight to the quiet abode of Aswan.'
    },
    {
      id: 3,
      name: 'Ethiopia',
      image: '/images/adventure-dest-3.jpg',
      description: 'Ethiopia is an ancient country whose unique cultural heritage, rich history, and remarkable biodiversity are reflected in a tally of nine UNESCO World Heritage Sites – more than any other country in Africa.',
      details: 'Within its borders, you\'ll find the world\'s fourth-holiest Islamic city, along with the oldest continuously occupied town south of the Sahara. Compelling antiquities include the medieval rock-hewn churches of Lalibela and Gheralta, ruined palaces and temples dating back 3,000 years, the magnificent 17th-century castles of Gondar, and the oldest human fossils unearthed anywhere on the planet.'
    },
    {
      id: 4,
      name: 'Kenya',
      image: '/images/adventure-dest-4.jpg',
      description: 'Unleash your adventurous spirit with Kenya\'s exhilarating sports and outdoor activities, from thrilling safaris to high-altitude treks!',
      details: 'Experience the Great Migration in Masai Mara, climb Mount Kenya, explore the Rift Valley lakes, and immerse yourself in Maasai culture. Kenya offers unparalleled wildlife viewing opportunities and diverse landscapes from coastal beaches to mountain highlands.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {destinations.map((destination, index) => (
          <div key={destination.id} className="mb-20 last:mb-0">
            <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''
              }`}>
              {/* Image */}
              <div className={`${index % 2 === 1 ? 'lg:col-start-2' : ''}`}>
                <div className="relative overflow-hidden rounded-lg shadow-lg">
                  <img
                    src={destination.image}
                    alt={destination.name}
                    className="w-full h-80 object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
              </div>

              {/* Content */}
              <div className={`${index % 2 === 1 ? 'lg:col-start-1' : ''}`}>
                <h2 className="text-4xl font-bold text-gray-900 mb-6">
                  {destination.name}
                </h2>
                <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                  {destination.description}
                </p>
                <p className="text-gray-600 leading-relaxed">
                  {destination.details}
                </p>
                <div className="mt-8">
                  <button
                    onClick={() => navigate(`/contact?subject=${encodeURIComponent('Enquiry about ' + destination.name)}`)}
                    className="bg-emerald-600 text-white px-8 py-3 rounded-lg hover:bg-emerald-700 transition-colors duration-200 font-medium whitespace-nowrap cursor-pointer"
                  >
                    Explore {destination.name}
                  </button>
                </div>
              </div>
            </div>

            {/* Divider */}
            {index < destinations.length - 1 && (
              <div className="mt-20">
                <div className="w-full h-px bg-gray-200"></div>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};
